export const FAKE_TOTALS = {
  projects: 3592,
  fleets: 2052,
  tenders: 1162,
}